export default "__VITE_ASSET__CedEE3w2__"